export default {"src":"/_next/static/media/pill_40.0ca2251d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};